var cov_6ard4u64h = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/CardGroup/styles/index.ts",
      hash = "99391122f8d650707ff4f8032e82471781148b2c",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/CardGroup/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 30
        },
        end: {
          line: 5,
          column: 69
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var cardGroupLess = {};
import genaration from '../../utils/classname';
export var cardGroupClass = (cov_6ard4u64h.s[0]++, genaration(cardGroupLess, 'card-group'));